import { Tag } from 'src/services/tag/Tag';
import { applyPreferredTagOrder } from './applyPreferredTagOrder';
import { DetailedTag } from 'src/services/tag/DetailedTag';

export function move(
  tags: DetailedTag[],
  tagToMove: DetailedTag,
  direction: 'up' | 'down' = 'up'
): DetailedTag[] {
  const ids = tags.map((tag) => tag.id!);

  let tagToSwapWith: DetailedTag | undefined;

  if (direction === 'up') {
    const previousTags = tags.slice(0, tags.indexOf(tagToMove));
    const previousTagsReversed = previousTags.reverse();

    tagToSwapWith = previousTagsReversed
      .filter((t) => t.isPeriodic === tagToMove.isPeriodic)
      .find(
        (tag) =>
          tag.fullPath.split('/').length ===
          tagToMove.fullPath.split('/').length
      );
  } else {
    const nextTags = tags.slice(tags.indexOf(tagToMove) + 1);
    tagToSwapWith = nextTags
      .filter((t) => t.isPeriodic === tagToMove.isPeriodic)
      .find(
        (tag) =>
          tag.fullPath.split('/').length ===
          tagToMove.fullPath.split('/').length
      );
  }

  if (!!tagToSwapWith) {
    const isNotSelf =
      direction === 'up'
        ? tags.indexOf(tagToSwapWith) < tags.indexOf(tagToMove)
        : tags.indexOf(tagToSwapWith) > tags.indexOf(tagToMove);

    if (isNotSelf) {
      swap(ids, tags.indexOf(tagToSwapWith), tags.indexOf(tagToMove));
      const newTags = applyPreferredTagOrder(ids, tags);
      return newTags;
    } else {
      return tags;
    }
  } else {
    return tags;
  }
}

function swap<T>(array: T[], index1: number, index2: number): void {
  const temp = array[index1];
  array[index1] = array[index2];
  array[index2] = temp;
}
